import uniqueId from './uniqueId';

const setupBreadcrumbAnalitycsTags = () => {
	let pageTitle: string = 'Not set';
    setTimeout(() => {
      // TODO: The metaName check is needed because there are pages where the title tag in the head is not set. When this is fixed, then this check can be removed.
      let metaName: string | undefined | null = document.querySelector('meta[property="og:title"]')?.getAttribute('content');
      if (metaName) {
        pageTitle = metaName;
      }
      if (document.title.length !== 0) {
        pageTitle = document.title;
      }
      // We can't access directly the actual Breadcrumb components because they are coming from an outside lib. 
      // Because of this we are finding the breadcumbs with pure js and then we modifyning those elements in place.
      const breadCrumbs: HTMLCollectionOf<Element> = document.getElementsByClassName('breadcrumbs__crumb');
      for (let breadCrumb of breadCrumbs) {
        if (breadCrumb.tagName === 'A') {
          breadCrumb.setAttribute('title', breadCrumb.innerHTML);
          breadCrumb.setAttribute(
            'data-analytics-element',
            uniqueId(breadCrumb.innerHTML)
          );
          breadCrumb.setAttribute('data-analytics-context', pageTitle);
          breadCrumb.setAttribute('data-analytics-category', 'Link');
        }
      }
    // We need to wait a bit to make sure that the page is loaded, before searching the breadcrumbs
    }, 500);
};

export default setupBreadcrumbAnalitycsTags;